import { z } from 'zod';

export const MileageSourceSchema = z.enum([
  'RECEPTION',
  'SERVICE_ORDER',
  'MANUAL',
  'OTHER',
  /** BR-VH-35: system-written when another tenant's mileage update raises this link's value. */
  'CROSS_WORKSHOP_SYNC',
]);

export type MileageSource = z.infer<typeof MileageSourceSchema>;

export const RecordVehicleMileageBodySchema = z.object({
  mileageKm: z.number().positive(),
  source: MileageSourceSchema,
  reason: z.string().trim().optional(),
});

export type RecordVehicleMileageBody = z.infer<typeof RecordVehicleMileageBodySchema>;

export const RecordVehicleMileageResponseSchema = z.object({
  mileageHistoryId: z.uuid(),
});

export type RecordVehicleMileageResponse = z.infer<typeof RecordVehicleMileageResponseSchema>;
